import APIConstant from 'constants/ApiConstant';
import { EDUCATION_WEB } from 'constants/RequestUrlConstant';
import { makeAutoObservable, runInAction } from 'mobx';
import { postRequest } from 'utils/apiUtils';
import { getValidDataFromResponse, isValidArray } from 'utils/utilities';

class EquipmentRegisterStore {
    equipmentList = []

    constructor() {
        makeAutoObservable(this);
    }

    getEquipmentList = async (body) => {
        console.log("🚀 ~ EquipmentRegisterStore ~ getEquipmentList= ~ body:", body)
        return new Promise(async (resolve, reject) => {
            try {
                const { response } = await postRequest({ url: APIConstant.GET_ALL_EQUIPMENT_DATA, rbu: EDUCATION_WEB, payload: body });;
                const { result, error } = getValidDataFromResponse({ response, isRequired: false });
                if (!error && isValidArray(result)) {
                    this.setEquipmentList(result);
                    resolve(result);
                }
                resolve([]);
            } catch (error) {
                reject(error);
            }
        })
    }


    setEquipmentList = (data = []) => {
        runInAction(() => {
            this.equipmentList = data;
        })
    }

}

export default EquipmentRegisterStore;